module.exports = __webpack_public_path__ + "static/media/upload_file.c8ea5051.svg";